module.exports = __webpack_public_path__ + "media/negative.fa324919.wav";